<ion-app>
  <ion-menu id="main-menu" contentId="main-content" type="overlay" [disabled]="userService.backendUser === undefined">
    <ion-content>
      <div class="ion-text-center logo">
        <img height="100" ngSrc="/assets/images/logo_dalkia_menu.png" width="157" alt="Dalkia" />
      </div>
      <div class="feedback-sos-row-container">
        @if (isToggleConsentGeolocEnabled() || isTogglePtiButtonSOSEnabled()) {
          <div class="feedback-sos-row">
            <div class="feedback-wrapper">
              @if (isToggleConsentGeolocEnabled()) {
                <feedback></feedback>
              }
            </div>
            <div class="sos-wrapper">
              @if (isTogglePtiButtonSOSEnabled()) {
                <sos></sos>
              }
            </div>
          </div>
        }
        <ion-item-divider></ion-item-divider>
      </div>

      <ion-list id="inbox-list">
        <ion-menu-toggle auto-hide="false" *ngFor="let item of links; let i = index">
          <ion-item
            [button]="true"
            (click)="navigateTo(item)"
            routerDirection="root"
            lines="none"
            detail="false"
            routerLinkActive="selected"
            *ngIf="isLinkVisible(item) && item?.visible"
            [disabled]="item.disabled"
            [id]="'menu_link_' + item?.action"
            detail-none
          >
            <div class="icon-with-badge">
              <ion-icon
                [ngClass]="item?.active ? 'selected' : item.highlight ? 'highlight' : ''"
                aria-hidden="true"
                slot="start"
                [name]="item.icon"
              ></ion-icon>
              <ion-badge *ngIf="item.notifications" class="badge-over-icon">{{ item.notifications }}</ion-badge>
            </div>
            <ion-label [ngClass]="item?.active ? 'selected' : item.highlight ? 'highlight' : ''">
              {{ item.title }}
            </ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-content>
    <ion-footer class="version_bloc">
      <p>{{ fullAppVersion }}</p>
    </ion-footer>
  </ion-menu>
  <ion-content id="main-content">
    <network-status [networkStatus]="networkStatus()"></network-status>
    <!-- retire 5% de la hauter dans le cas où le network-status est visible -->
    <ion-router-outlet
      [animated]="false"
      class="content"
      [ngClass]="{ open: networkStatus() !== NetworkStatusEnum.ONLINE }"
      [style.height]="contentHeight()"
    ></ion-router-outlet>
  </ion-content>
  <div *ngIf="showChrono && hasChrono()">
    <chrono></chrono>
  </div>
  <div *ngIf="showChrono && hasActiviteEncours()">
    <bandeau-activite [activiteEncours]="activiteEncours()" [chronoEnCours]="chronoEnCours()"></bandeau-activite>
  </div>
  <ion-footer>
    <footer-new-version [isMntDiffus]="isMntDiffus"></footer-new-version>
  </ion-footer>
</ion-app>
